import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2aa06462"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "score-rule-page"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "摩点官方抽奖活动规则", -1));
const _hoisted_3 = {
  key: 1,
  style: {
    "height": "15px"
  }
};
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = {
  class: "rule-content"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "一、活动概述"), /*#__PURE__*/_createElementVNode("p", null, "该活动是依托平台积分体系打造的抽奖活动，预估每日50w+曝光。以平台积分为媒介，深度连接\"用户\"与\"项目发起人\"，为参与的活动众筹项目精准引流，实现曝光与筹资的双提升。")], -1));
const _hoisted_7 = {
  class: "section"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "二、活动曝光资源：超核心广告位，登陆用户全覆盖", -1));
const _hoisted_9 = {
  class: "list-item"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "app&小程序 ：「我的页面—积分商城」", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看示意", -1));
const _hoisted_12 = {
  class: "image-container"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/score_activity/example_tip1.png",
  alt: "示意图"
}, null, -1));
const _hoisted_14 = [_hoisted_13];
const _hoisted_15 = {
  class: "list-item"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "app：「首页—icon」", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看示意", -1));
const _hoisted_18 = {
  class: "image-container"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/score_activity/example_tip2.png",
  alt: "示意图"
}, null, -1));
const _hoisted_20 = [_hoisted_19];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "全量用户push推送+私域推送", -1));
const _hoisted_22 = {
  class: "section"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "三、商家权益：三重特权加持，曝光拉满", -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "金币奖励：审核通过，最高15000金币（免单档最高1w金币+特价档最高5k金币；按活动让利货值10倍返）", -1));
const _hoisted_25 = {
  class: "list-item"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "积分抽奖页面露出，每日10w+曝光", -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看示意", -1));
const _hoisted_28 = {
  class: "image-container"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/score_activity/example_tip3.png",
  alt: "示意图"
}, null, -1));
const _hoisted_30 = [_hoisted_29];
const _hoisted_31 = {
  class: "list-item"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "用户任务优先展示", -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看示意", -1));
const _hoisted_34 = {
  class: "image-container"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/score_activity/example_tip4.png",
  alt: "示意图"
}, null, -1));
const _hoisted_36 = [_hoisted_35];
const _hoisted_37 = /*#__PURE__*/_createStaticVNode("<div class=\"section\" data-v-2aa06462><div class=\"title\" data-v-2aa06462>四、报名要求</div><ul data-v-2aa06462><li data-v-2aa06462>项目状态：&quot;项目过审——众筹结束前7天&quot;可报名</li><li data-v-2aa06462>回报档要求：独家首发的回报档，加购档不可报名</li><li data-v-2aa06462>回报档售价：需不高于同类商品市场价，否则报名不予通过</li></ul></div><div class=\"section\" data-v-2aa06462><div class=\"title\" data-v-2aa06462>五、展示时间</div><p data-v-2aa06462>审核通过-众筹结束前72小时</p></div><div class=\"section\" data-v-2aa06462><div class=\"title\" data-v-2aa06462>六、审核时效</div><p data-v-2aa06462>提报名3工作日内反馈审核结果，审核通过后无法退出活动。</p></div>", 3);
import { reactive } from "vue";
import { env } from "md-base-tools/env";
import { GoBack } from "../../utils/tools";
export default {
  setup(__props) {
    const state = reactive({
      isFix: 0,
      expandedItems: [false, false, false, false] // 展开状态管理（4个可展开项）
    });
    function handleGoBack() {
      GoBack();
    }
    function handleStickyAction(is_fix) {
      state.isFix = is_fix ? 1 : 0;
    }

    // 切换图片显示/隐藏
    const toggleImage = index => {
      state.expandedItems[index] = !state.expandedItems[index];
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_sticky = _resolveComponent("van-sticky");
      const _component_van_icon = _resolveComponent("van-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!_unref(env).isWeixin() && !_unref(env).isModianAndroid() && !_unref(env).isModianIos() && !_unref(env).isModianIosNew() ? (_openBlock(), _createBlock(_component_van_sticky, {
        key: 0,
        onChange: handleStickyAction
      }, {
        default: _withCtx(() => [_createElementVNode("header", {
          class: _normalizeClass([{
            'headerAndroid': _unref(env).isModianAndroid()
          }, {
            'isFix': _unref(state).isFix
          }])
        }, [_createVNode(_component_van_image, {
          class: "back-btn",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/score_activity/score_back.png', 40),
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleGoBack(), ["stop"]))
        }, null, 8, ["src"]), _hoisted_2], 2)]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_3)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("ul", null, [_createElementVNode("li", null, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", {
        class: "toggle-btn",
        onClick: _cache[1] || (_cache[1] = $event => toggleImage(0))
      }, [_hoisted_11, _createVNode(_component_van_icon, {
        name: _unref(state).expandedItems[0] ? 'arrow-up' : 'arrow-down'
      }, null, 8, ["name"])])]), _createVNode(_Transition, {
        name: "expand"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_12, _hoisted_14, 512), [[_vShow, _unref(state).expandedItems[0]]])]),
        _: 1
      })]), _createElementVNode("li", null, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", {
        class: "toggle-btn",
        onClick: _cache[2] || (_cache[2] = $event => toggleImage(1))
      }, [_hoisted_17, _createVNode(_component_van_icon, {
        name: _unref(state).expandedItems[1] ? 'arrow-up' : 'arrow-down'
      }, null, 8, ["name"])])]), _createVNode(_Transition, {
        name: "expand"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_18, _hoisted_20, 512), [[_vShow, _unref(state).expandedItems[1]]])]),
        _: 1
      })]), _hoisted_21])]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("ul", null, [_hoisted_24, _createElementVNode("li", null, [_createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", {
        class: "toggle-btn",
        onClick: _cache[3] || (_cache[3] = $event => toggleImage(2))
      }, [_hoisted_27, _createVNode(_component_van_icon, {
        name: _unref(state).expandedItems[2] ? 'arrow-up' : 'arrow-down'
      }, null, 8, ["name"])])]), _createVNode(_Transition, {
        name: "expand"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_28, _hoisted_30, 512), [[_vShow, _unref(state).expandedItems[2]]])]),
        _: 1
      })]), _createElementVNode("li", null, [_createElementVNode("div", _hoisted_31, [_hoisted_32, _createElementVNode("div", {
        class: "toggle-btn",
        onClick: _cache[4] || (_cache[4] = $event => toggleImage(3))
      }, [_hoisted_33, _createVNode(_component_van_icon, {
        name: _unref(state).expandedItems[3] ? 'arrow-up' : 'arrow-down'
      }, null, 8, ["name"])])]), _createVNode(_Transition, {
        name: "expand"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_34, _hoisted_36, 512), [[_vShow, _unref(state).expandedItems[3]]])]),
        _: 1
      })])])]), _hoisted_37])])]);
    };
  }
};